// extracted by mini-css-extract-plugin
module.exports = {"quiz":"Quiz_quiz__M8BcY","quiz__questions":"Quiz_quiz__questions__2K7wE","quiz__button":"Quiz_quiz__button__1gMQ7","quiz__errorBlock":"Quiz_quiz__errorBlock__I9tK3"};